import { Container } from "@mantine/core";
import { QuickBitesView } from "../components/QuickBites/QuickBitesView";
import { usePageTitle } from "../hooks/usePageTitle";

export const QuickBitesPage = () => {
  usePageTitle('Quick Bites | Meals You Love');
  return (
    <Container size="xl" py="xl">
      <QuickBitesView />
    </Container>
  );
};
